export default __webpack_public_path__ + "static/media/DomesticViolence_TheVictimsAroundUs.ad745da9.pdf";